import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { CustomerActivity, CustomerActivityType } from "../../../types";
import { useStyles } from "./styles";

type Props = {
  rows: CustomerActivity[];
};

const getActivityIcon = (type: CustomerActivityType) => {
  switch (type) {
    case "FINANCIAL":
      return <PaidOutlinedIcon />;
    case "CUSTOMER":
      return <PersonOutlineOutlinedIcon />;
    default:
      return <FolderOutlinedIcon />;
  }
};

const TimeLine = ({ rows }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  if (!rows.length) {
    return (
      <Box className={styles.root}>
        <Typography className={styles.empty}>
          {t("CUSTOMERS.DETAILS.TIMELINE.EMPTY")}
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {rows.map((row) => (
        <Box key={row.id} className={styles.entryRow}>
          <Box className={styles.iconBadge}>{getActivityIcon(row.type)}</Box>

          <Box className={styles.card}>
            <Box className={styles.headerRow}>
              <Typography className={styles.title}>{row.title}</Typography>
              <Typography className={styles.date}>{row.date}</Typography>
            </Box>
            <Typography className={styles.description}>{row.description}</Typography>
          </Box>
        </Box>
      ))}
    </>
  );
};

export default TimeLine;
